import { api } from './api';
import { API_ENDPOINTS } from '../config';
import { showToast } from './toastManager';

export async function openDodoCheckout(planCode: string): Promise<void> {
  const data = await api.post<{ checkout_url: string }>(
    API_ENDPOINTS.payments.createCheckout,
    { plan_code: planCode }
  );

  if (!data?.checkout_url) {
    showToast('Failed to create checkout session. Please try again.', 'error');
    throw new Error('No checkout_url returned from backend');
  }

  window.location.href = data.checkout_url;
}
